{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/accordion-item",
	"title": "Accordion Item",
	"category": "design",
	"description": "Wraps the heading and panel in one unit.",
	"parent": [ "core/accordion" ],
	"allowedBlocks": [ "core/accordion-heading", "core/accordion-panel" ],
	"supports": {
		"html": false,
		"color": {
			"background": true,
			"gradients": true
		},
		"interactivity": true,
		"spacing": {
			"margin": [ "top", "bottom" ],
			"padding": true,
			"blockGap": true
		},
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true,
			"__experimentalDefaultControls": {
				"color": true,
				"radius": true,
				"style": true,
				"width": true
			}
		},
		"shadow": true,
		"layout": {
			"allowEditing": false
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"contentRole": true
	},
	"attributes": {
		"openByDefault": {
			"type": "boolean",
			"default": false
		}
	},
	"providesContext": {
		"core/accordion-open-by-default": "openByDefault"
	},
	"textdomain": "default",
	"style": "wp-block-accordion-item"
}
